import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './DateStamp.scss';

export default function DateStamp({ className, size, month, day }) {
  const classNames = cn('cp-date-stamp', className, `date-stamp--${size}`);

  return (
    <div className={classNames}>
      <div className="date-stamp__month" aria-hidden="true">
        {month}
      </div>
      <div className="date-stamp__day" aria-hidden="true">
        {day}
      </div>
    </div>
  );
}

DateStamp.propTypes = {
  className: PropTypes.string,
  month: PropTypes.string.isRequired,
  day: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  size: PropTypes.oneOf(['default', 'large'])
};

DateStamp.defaultProps = {
  size: 'default'
};
